const embeddedRevision = process.env.VUE_APP_RELEASE_SHA || 'development';
const eventName = 'clockspotter:stale-release';
let installed = false;
export const RELEASE_CHECK_TIMEOUT_MS = 5000;

async function fetchLiveRevision(timeoutMs = RELEASE_CHECK_TIMEOUT_MS) {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await fetch(`/version.json?revisionCheck=${Date.now()}`, {
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache' },
      signal: controller.signal,
    });
    return response.ok ? await response.json() : null;
  } finally {
    window.clearTimeout(timeout);
  }
}

async function clearObsoleteBrowserState() {
  if ('caches' in window) await Promise.all((await caches.keys()).map((key) => caches.delete(key)));
  if ('serviceWorker' in navigator) await Promise.all((await navigator.serviceWorker.getRegistrations()).map((registration) => registration.unregister()));
}

export async function checkReleaseRevision({ bootstrap = false, timeoutMs = RELEASE_CHECK_TIMEOUT_MS } = {}) {
  if (embeddedRevision === 'development') return true;
  try {
    const value = await fetchLiveRevision(timeoutMs);
    const liveRevision = value?.revision;
    if (!liveRevision || liveRevision === embeddedRevision) return true;
    window.__clockspotterStaleBuild = true;
    if (bootstrap && sessionStorage.getItem('clockspotter:last-release-reload') !== liveRevision) {
      sessionStorage.setItem('clockspotter:last-release-reload', liveRevision);
      await clearObsoleteBrowserState();
      window.location.reload();
      return false;
    }
    window.dispatchEvent(new CustomEvent(eventName, { detail: { embeddedRevision, liveRevision } }));
    // If a cache or intermediary still serves the old bootstrap after the one safe
    // reload, mount the app in read-only mode so the user sees the refresh notice
    // instead of a blank page. Mutations remain blocked by httpClient.
    return bootstrap;
  } catch (_) {
    return true;
  }
}

export function installReleaseGuard() {
  if (installed) return;
  installed = true;
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') checkReleaseRevision(); });
}

export const staleReleaseEvent = eventName;
